export enum OrderDeliveryTypeEnum {
  INDIVIDUAL_ADDRESS = 'INDIVIDUAL_ADDRESS',
  BENEFICIARY = 'BENEFICIARY',
  COMPANY_ONE_DELIVERY_POINT = 'COMPANY_ONE_DELIVERY_POINT',
  COMPANY_SEVERAL_DELIVERY_POINTS = 'COMPANY_SEVERAL_DELIVERY_POINTS'
}
